import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import './vendor/jquery.validate.min.js';
import modal from '../patterns/modal.js';
import utils from '../patterns/utils.js';
import PL_utils from '../patterns/pl-utils.js';


const body = document.querySelector('body');
const modalOpts = {
    enableBackdropClose: true
};

// ModalHooks for screenshot
const ssHooks = {
    _hasScrolledToBottom: false,
    _addModalError: function (target) { },
    _removeModalError: function (target) { },
    beforeOpen: function (target) {
        PL_utils.addClass('modal-open', body);
    },
    afterOpen: function (target) { },
    onContinue: function (e, target) { },
    onCancel: function () {
        return false;
    },
    beforeClose: function () {
        document.querySelectorAll('.modal').forEach((item) => {
            if (!item.getAttribute("hidden")) {
                item.setAttribute('hidden', "");
                item.setAttribute("aria-hidden", true);
            }
        });
        return false;
    },
    afterClose: function () {
        PL_utils.removeClass('modal-open', body);
        closeElementFocus();
    },
    setSize: function () {
        return false;
    },
    onScreenshot: function () {
        return false;
    },
    onInit: function (target) {

    }
};

const showSSModal = (modalID) => {
    const errorModal = modal.initModal(document.querySelector(modalID), ssHooks, modalOpts);
    errorModal.showModal();
};

export default () => {
    const id = utils.getParam('id');
    var addressOldValue = document.querySelector('#edit-address').value;
    var stateOldValue = document.querySelector('#edit-address-state').value;
    var cityOldValue = document.querySelector('#edit-city').value;
    var zipcodeOldValue = document.querySelector('#edit-zipcode').value;

    const showErrorMessage = (fieldId, labelId) => {
        const field = document.getElementById(fieldId);
        const fieldLabelError = document.querySelector(`#${labelId} > p.form-error`);
        field.setAttribute("aria-invalid", "true");
        field.classList.add("error");
        fieldLabelError.classList.remove("hidden");
    };
    
    //Only allow the following to be typed in: digits, blank spaces, (, ), -
    document.getElementById("edit-phone").addEventListener("input", (e) => {
        const replaceRegex = /[^()\d\s-]/g;
        e.target.value = e.target.value.replace(replaceRegex, "");
    });

    $.validator.addMethod("digitsOnly", function(value, element) {
        return this.optional(element) || /^\d{10}$/.test(value.replace(/\D/g, ""));
      }, "");

    $('#edit-listings-form').validate({
        onkeyup: false,
        rules: {
            'edit-address': {
                required: true
            },
            'edit-address-state': {
                required: true
            },
            'edit-city': {
                required: true
            },
            'edit-zipcode': {
                required: true,
                digits: true,
                minlength: 5,
            },
            'edit-phone': {
                required: true,
                minlength: 10,
                digitsOnly: true,
            },
            'agreement-chk': {
                required: true
            },
            'edit-signature': {
                required: true
            }
        },
        showErrors: function (errorMap, errorList) {
            // The arguments in errorList contain only those elements currently validated.
            // Refer to the form.successList for all the valid field,
            // and remove the error message that's associated to it.
            // Ref: https://jqueryvalidation.org/validate/  => showErrors
            this.successList.forEach((e) => {
                const targetName = e.name;
                const targetElements = $(`[name='${targetName}']`);
                const errorElement = $(`#${targetName}-label .form-error`);

                targetElements.removeClass('error');
                errorElement.addClass('hidden');

                if (targetName == "edit-phone") {
                    $('#edit-ext').removeClass('error-padding');
                }
            });

            errorList.forEach((error) => {
                const targetName = error.element.name;
                const { method } = error;
                const targetElements = $(`[name='${targetName}']`);
                const errorElement = $(`#${targetName}-label .form-error`);

                targetElements.addClass('error');
                errorElement.removeClass('hidden');

                window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Edit Listing', 'Form_Field': targetName, 'Form_Field_Error': errorElement.text(), });

                targetElements.attr('aria-invalid', 'true');

                console.log(targetName);
                if (targetName == "edit-phone") {
                    $('#edit-ext').addClass('error-padding');
                }
            });
        },
        submitHandler: function (form) {
            //Submit the form
            window.dataLayer.push({ 'event': 'Form_Success', 'Form_Name': 'Edit Listing', });

            const formData = $(form).serializeArray();
            const postData = { 'anonymousToken': utils.getAnonymousToken(), 'edit-address-id': id };

            formData.forEach(function (field) {
                postData[field.name] = field.name == "edit-phone" ? field.value.replace(/\D/g, "") : field.value;
            });

            utils.setButtonLoadingState('#edit-listing-submit', '#edit-listing-loading', true);

            $.ajax(global.API_ENDPOINT() + '/location/update', {
                data: JSON.stringify(postData),
                dataType: 'json',
                method: 'POST',
                headers: {
                    'csrf-token': utils.getCookie('csrfToken'),
                },
                xhrFields: {
                    withCredentials: true,
                }
            })
            .done(function (resp) {
                if (resp.success) {
                    window.location.href = "/request-confirmation";
                } else if (resp.data.errorCode == 'E001' || resp.data.errorCode == 'E002') {
                    console.error(JSON.stringify(resp));
                    window.location.href = "/";
                } else if (resp.data.errorCode == "E701") {
                    console.error(JSON.stringify(resp));
                    Object.keys(resp.errors["dataservice-httpjson-validate"]).forEach(e =>  {
                        if(e == "edit-address" || e == "edit-latitude" || e == "edit-longitude") {
                            showErrorMessage("edit-address", "edit-address-label");
                        } 
                        if (e == "edit-address-state") {
                            showErrorMessage("edit-address-state", "edit-address-state-label");
                        } 
                        if (e == "edit-city") {
                            showErrorMessage("edit-city", "edit-city-label");
                        } 
                        if (e == "edit-zipcode") {
                            showErrorMessage("edit-zipcode", "edit-zipcode-label");
                        } 
                        if (e == "edit-phone") {
                            showErrorMessage("edit-phone", "edit-phone-label");
                        } 
                        if (e == "agreement-chk") {
                            showErrorMessage("agreement-chk", "agreement-chk-label");
                        } 
                        if (e == "edit-signature") {
                            showErrorMessage("edit-signature", "edit-signature-label");
                        }
                    })
                    document.querySelector('[aria-invalid="true"]').focus();
                } else {
                    console.error(JSON.stringify(resp));
                    window.location.href = "/server-error";
                }
                utils.setButtonLoadingState('#edit-listing-submit', '#edit-listing-loading', false);
            })
            .fail(function (err) {
                console.error(JSON.stringify(err));
                utils.setButtonLoadingState('#edit-listing-submit', '#edit-listing-loading', false);
                window.location.href = '/server-error';
            })
        },
        invalidHandler: function(form, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
              validator.errorList[0].element.focus();
            }
          }
    });

    // Populate state dropdown
    const session = utils.getSession();
    if (session) {
        const stateEl = document.querySelector('#edit-address-state');

        Object.keys(session.deaState)
        .forEach(function(state) {
            const option = document.createElement('option');
            option.value = state;
            option.text = global.STATE_LIST[state];

            stateEl.appendChild(option);
        })
    }

    // Get listing details
    if (global.IS_ED_MODE) {
        if (utils.getParam('modal') == 'unsaved') {
            showSSModal('.modal-unsaved-changes');
        } else if (utils.getParam('modal') == 'delete') {
            showSSModal('.modal-delete-listings');
        }

    } else if (id) {
        PL_utils.addClass('hidden', document.querySelector('.map-placeholder'))
        PL_utils.removeClass("hidden", document.querySelector("#edit-listing-map-loading"));
        $.ajax(global.API_ENDPOINT() + '/location/list', {
            dataType: 'json',
            method: 'GET',
            headers: {
                'csrf-token': utils.getCookie('csrfToken'),
            },
            xhrFields: {
                withCredentials: true,
            }
        })
        .done(function (resp) {
            PL_utils.addClass('hidden', document.querySelector('#edit-listing-map-loading'));
            PL_utils.removeClass('hidden', document.querySelector('.map-container'));
            if (resp.success) {
                const address = resp.data.addresses.filter(function(a) { return a.LocationId == id; })[0];
                if (address) {
                    var pending;
                    if (pending = global.PENDING_STATUS_LIST[utils.toLowercase(address.Status)]) {
                        PL_utils.removeClass('hidden', document.querySelector('.svg-pending'));
                        document.querySelector('#edit-status').innerText = pending;
                    }
                    document.querySelector('#edit-practice-name').value = address.PracticeName;
                    document.querySelector('#edit-address').value = address.Address;
                    document.querySelector('#edit-address-state').value = address.State;
                    document.querySelector('#edit-city').value = address.City;
                    document.querySelector('#edit-zipcode').value = address.Zip;
                    document.querySelector('#edit-latitude').value = address.Latitude;
                    document.querySelector('#edit-longitude').value = address.Longitude;
                    document.querySelector('#edit-phone').value = address.PhoneNumber;
                    document.querySelector('#edit-ext').value = address.PhoneExt;

                    addressOldValue = address.Address;
                    stateOldValue = address.State;
                    cityOldValue = address.City;
                    zipcodeOldValue = address.Zip;

                    // Callback function to update latitude/longitude form fields.
                    const updateLatLng = (latLng) => {
                        document.querySelector('#edit-latitude').value = latLng.lat();
                        document.querySelector('#edit-longitude').value = latLng.lng();
                    };
                    // Generates an editable Google map.
                    const { map, marker } = utils.renderGoogleMap(address.Latitude, address.Longitude, 'googlemap-edit-listing');

                } else {
                    console.log('Could not find address');
                    window.location.href = "/listings";
                }
            } else if (resp.data.errorCode == 'E001' || resp.data.errorCode == 'E002') {
                console.error(JSON.stringify(resp));
                window.location.href = "/";
            } else {
                console.error(JSON.stringify(resp));
                window.location.href = "/server-error";
            }
        })
        .fail(function (err) {
            console.error(JSON.stringify(err));
            PL_utils.addClass("hidden", document.querySelector("#edit-listing-map-loading"));
            window.location.href = "/server-error";
        })
    } else {
        window.location.href = "/listings";
    }

    // Lookup address after form populated
    const lookupAddress = function () {
        const addressNewValue = document.querySelector('#edit-address').value;
        const stateNewValue = document.querySelector('#edit-address-state').value;
        const cityNewValue = document.querySelector('#edit-city').value;
        const zipcodeNewValue = document.querySelector('#edit-zipcode').value;

        if ((addressNewValue && stateNewValue && cityNewValue && zipcodeNewValue)
                && (addressNewValue + stateNewValue + cityNewValue + zipcodeNewValue != addressOldValue + stateOldValue + cityOldValue + zipcodeOldValue)) {
            PL_utils.addClass('hidden', document.querySelector('.map-placeholder'))
            PL_utils.addClass('hidden', document.querySelector('.map-container'))
            PL_utils.removeClass("hidden", document.querySelector("#edit-listing-map-loading"));
            $.ajax(global.API_ENDPOINT() + '/address/lookup', {
                data: JSON.stringify({
                    'anonymousToken': utils.getAnonymousToken(),
                    'address': addressNewValue,
                    'state': stateNewValue,
                    'city': cityNewValue,
                    'zipcode': zipcodeNewValue,
                }),
                dataType: 'json',
                method: 'POST',
                headers: {
                    'csrf-token': utils.getCookie('csrfToken'),
                },
                xhrFields: {
                    withCredentials: true,
                }
            })
            .done(function (resp) {
                PL_utils.addClass("hidden", document.querySelector("#edit-listing-map-loading"));
                if (resp.success) {
                    document.querySelector('#edit-latitude').value = resp.data.latitude;
                    document.querySelector('#edit-longitude').value = resp.data.longitude;

                    // Callback function to update latitude/longitude form fields.
                    const updateLatLng = (latLng) => {
                        document.querySelector('#edit-latitude').value = latLng.lat();
                        document.querySelector('#edit-longitude').value = latLng.lng();
                    };
                    // Generates an editable Google map.
                    const { map, marker } = utils.renderGoogleMap(resp.data.latitude, resp.data.longitude, 'googlemap-edit-listing');
                    PL_utils.removeClass('hidden', document.querySelector('.map-container'))

                } else if (resp.data.errorCode == 'E001' || resp.data.errorCode == 'E002') {
                    console.error(JSON.stringify(resp));
                    window.location.href = "/";
                } else {
                    console.error(JSON.stringify(resp));
                }
            })
            .fail(function (err) {
                console.error(JSON.stringify(err));
                PL_utils.addClass("hidden", document.querySelector("#edit-listing-map-loading"));
            })
        } else if ( !addressNewValue || !stateNewValue || !cityNewValue || !zipcodeNewValue) {
            if ( !window.location.href.indexOf('ed=1' > -1)) {
                PL_utils.addClass('hidden', document.querySelector('.map-container'));
            PL_utils.removeClass('hidden', document.querySelector('.map-placeholder'));
            }
        }

        addressOldValue = addressNewValue;
        stateOldValue = stateNewValue;
        cityOldValue = cityNewValue;
        zipcodeOldValue = zipcodeNewValue;
    }

    document.querySelector('#edit-address').addEventListener('blur', lookupAddress);
    document.querySelector('#edit-address-state').addEventListener('blur', lookupAddress);
    document.querySelector('#edit-city').addEventListener('blur', lookupAddress);
    document.querySelector('#edit-zipcode').addEventListener('blur', lookupAddress);

    // Bind delete button
    document.querySelector('#edit-delete').addEventListener('click', function(e) {
        e.preventDefault();

        const modalHooks = {
            _hasScrolledToBottom: false,
            _addModalError: function (target) { },
            _removeModalError: function (target) { },
            beforeOpen: function (target) {
                PL_utils.addClass('modal-open', body);
            },
            afterOpen: function (target) { },
            onDelete: function (e, target) {
                window.dataLayer.push({ 'event': 'Form_Success', 'Form_Name': 'Delete Listing', });

                const postData = { 'anonymousToken': utils.getAnonymousToken(), 'delete-address-id': id };
                utils.setButtonLoadingState("#delete-listing", "#delete-listing-loading", true);

                $.ajax(global.API_ENDPOINT() + '/location/delete', {
                    data: JSON.stringify(postData),
                    dataType: 'json',
                    method: 'POST',
                    headers: {
                        'csrf-token': utils.getCookie('csrfToken'),
                    },
                    xhrFields: {
                        withCredentials: true,
                    }
                })
                .done(function (resp) {
                    if (resp.success) {
                        window.location.href = "/request-confirmation";
                    } else if (resp.data.errorCode == 'E001' || resp.data.errorCode == 'E002') {
                        console.error(JSON.stringify(resp));
                        window.location.href = "/";
                    } else {
                        console.error(JSON.stringify(resp));
                        window.location.href = "/server-error";
                    }
                    utils.setButtonLoadingState("#delete-listing", "#delete-listing-loading", false);
                })
                .fail(function (err) {
                    console.error(JSON.stringify(err));
                    utils.setButtonLoadingState("#delete-listing", "#delete-listing-loading", false);
                    window.location.href = '/server-error';
                })
            },
            onCancel: function () {
                return false;
            },
            beforeClose: function () {
                document.querySelectorAll('.modal').forEach((item) => {
                    if (!item.getAttribute("hidden")) {
                        item.setAttribute('hidden', "");
                        item.setAttribute("aria-hidden", true);
                    }
                });
                return false;
            },
            afterClose: function () {
                PL_utils.removeClass('modal-open', body);
                e.target.focus();
            },
            setSize: function () {
                return false;
            },
            onScreenshot: function () {
                return false;
            },
            onInit: function (target) {

            }
        };

        const deleteModal = modal.initModal(document.querySelector('.modal-delete-listings'), modalHooks, modalOpts);
        deleteModal.showModal();
    })

    // Bind leaving unsaved
    document.querySelectorAll('a:not(.modal__continue)').forEach(function (a) {
        if(a.getAttribute("href") !== "#" && a.getAttribute("href") !== "mailto:HCP_INFO@Indivior.com") {
            a.addEventListener('click', function(e) {
                e.preventDefault();
    
                const modalHooks = {
                    _hasScrolledToBottom: false,
                    _addModalError: function (target) { },
                    _removeModalError: function (target) { },
                    beforeOpen: function (target) {
                        PL_utils.addClass('modal-open', body);
                        target.querySelector('.modal__continue').setAttribute('href', a.href);
                        target.querySelector('.modal__continue').setAttribute('target', a.target||"_self");
                    },
                    afterOpen: function () { },
                    onContinue: function () { },
                    onCancel: function () {
                        return false;
                    },
                    beforeClose: function () {
                        document.querySelectorAll('.modal').forEach((item) => {
                            if (!item.getAttribute("hidden")) {
                                item.setAttribute('hidden', "");
                                item.setAttribute("aria-hidden", true);
                            }
                        });
                        return false;
                    },
                    afterClose: function () {
                        PL_utils.removeClass('modal-open', body);
                        a.focus();
                    },
                    setSize: function () {
                        return false;
                    },
                    onScreenshot: function () {
                        return false;
                    },
                    onInit: function (target) {
    
                    }
                };
    
                const unsavedModal = modal.initModal(document.querySelector('.modal-unsaved-changes'), modalHooks, modalOpts);
                unsavedModal.showModal();
            })
        }
    })
}
